module.exports = __webpack_public_path__ + "static/img/gree_arrow.69ec6e32.jpg";